import React from 'react';

import { MonetizationSvg } from './MonetizationSvg';
import { AnalyticsSvg } from './AnalyticsSvg';
import { ToolsSvg } from './ToolsSvg';
import { DistributionSvg } from './DistributionSvg';
import { MusicSvg } from './MusicSvg';

const FeaturesSvgs = ({ svgType }) => {
  switch (svgType) {
    case 'analytics':
      return <AnalyticsSvg />;
    case 'tools':
      return <ToolsSvg />;
    case 'distribution':
      return <DistributionSvg />;
    case 'monetization':
      return <MonetizationSvg />;
    case 'music':
      return <MusicSvg />;
    default:
      return null;
  }
};
export { FeaturesSvgs };
